import React, {useState} from 'react'

import {makeStyles} from '@mui/styles';

import {Box, Button, Collapse, Divider, IconButton, TextField, Tooltip, Typography} from '@mui/material';
import {Close, Help} from "@mui/icons-material";
import {amazonTag} from "../../../data/constants";
import Ingredient from "../../Recipes/Ingredients/Ingredient";
import {useDispatch, useSelector} from "react-redux";
import {removeItemFromCart, UpdateItemInCart, EditIngredientInCart} from "../../../Store/reducers/shoppingCartReducer";
import {UpdateSelectedRecipe} from "../../../Store/reducers/recipeReducer";
import {nav} from "../../../helper/navHelper";

const useStyles = makeStyles(theme => ({
    parent: {
        overflowY: "auto",
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
    },
    ingredientCard: {
        display:"flex",
        flexDirection:"column",
        width: "100%",
        maxWidth: "450px",
        padding: "4px 8px",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        borderRadius: 0,
        backgroundColor: theme.palette?.background?.default,
        boxSizing: "border-box",
        overflow: "hidden",
    },
    addButtons: {
        height: "3em",
        justifyContent: "space-around",
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
    },
    form: {
        flex: "1",
        display: "flex",
        justifyContent: "center",
    },
    button: {
        height: "100%",
        width: "40%",
    },
    ingredientList: {
        height: "100%",
        overflowY: "auto",
        overflowX:"hidden",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
    unverifiedIngredients: {
        paddingLeft: "20px",
        paddingRight: "20px",
        fontStyle: "italic"
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
    },
    paper1: {
        marginTop: theme?.spacing?.(8),
        display: 'flex',
        minWidth: "200px",
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'white',
        width: '50vw',
        marginLeft: "auto",
        marginRight: "auto",
        padding: "20px",
        borderRadius: "20px",
    },
    portionsInput: {
        width: '40px',
        '& input': {
            fontSize: '0.75rem',
            padding: '2px',
        },
    },
    recipeList: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    recipeListItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '4px 0',
        minHeight: '4.5em',
    },
    recipeListImage: {
        width: '4.5em',
        height: '4.5em',
        objectFit: 'cover',
        borderRadius: '4px',
    },
    recipeListInfo: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    recipeListName: {
    },
    recipeListPortions: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
    },
    recipeListClose: {
        padding: '2px',
    },
    tabButtons: {
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        backgroundColor: theme.palette?.background?.default,
        width: '100%',
        maxWidth: '450px',
        marginBottom: '8px',
    },
    tabButton: {
        flex: 1,
        borderRadius: 0,
        minWidth: 0,
    },
    tabButtonActive: {
        backgroundColor: theme.palette?.secondary?.main,
        color: '#fff',
        '&:hover': {
            backgroundColor: theme.palette?.secondary?.main,
        },
    },
    tabButtonInactive: {
        backgroundColor: theme.palette?.background?.default,
        color: theme.palette?.secondary?.main,
        border: `1px solid ${theme.palette?.secondary?.main}`,
    },
    // Recipe canvas container
    recipeCanvas: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '450px',
        padding: '4px 8px',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderRadius: 0,
        backgroundColor: theme.palette?.background?.default,
        boxSizing: 'border-box',
        overflow: 'hidden',
    },
    listHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    categoryHeader: {
        display: 'block',
        fontWeight: 500,
        padding: '8px 0 4px 0',
        color: theme.palette?.secondary?.main,
    },

}));


export default function CheckoutFSBig({ingredientList, recipes, baskets, unverifiedBasket, setCompany, company, brandID}) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const ingredientCategories = useSelector(state => state.global.ingredientCategories);
    const [activeTab, setActiveTab] = useState('recipes'); // 'recipes', 'ingredients'

    const handleRemoveRecipe = (recipeId) => {
        removeItemFromCart(dispatch, recipeId);
    };

    const handleUpdatePortions = (recipe, newPortions) => {
        dispatch({
            type: UpdateItemInCart,
            payload: { id: recipe.id, reqPortions: parseInt(newPortions) || 1 }
        });
    };

    const handleRecipeClick = (recipe) => {
        dispatch({ type: UpdateSelectedRecipe, payload: recipe });
        nav(dispatch, "/Recipe");
    };

    const handleIngredientUpdate = (ingredientId, qtyType, qty) => {
        dispatch({
            type: EditIngredientInCart,
            payload: { id: ingredientId, qtyType, qty }
        });
    };

    // Render list view
    const renderListView = () => (
        <div className={classes.recipeCanvas}>
            <div className={classes.recipeListItem} style={{ minHeight: 'auto', padding: 0, paddingBottom: '4px' }}>
                <Typography variant="body2" style={{ width: '4.5em' }}>Recipe</Typography>
                <div style={{ flex: 1 }}></div>
                <Typography variant="body2" style={{ width: '40px' }}>Portions</Typography>
                <div style={{ width: '18px' }}></div>
            </div>
            <Divider />
            <div className={classes.recipeList}>
                {recipes.map((recipe) => (
                    <React.Fragment key={recipe.id}>
                        <div className={classes.recipeListItem}>
                            <img
                                src={recipe.imageData || `${process.env.PUBLIC_URL}/notFoundImage.svg`}
                                alt={recipe.recipeName}
                                className={classes.recipeListImage}
                                onClick={() => handleRecipeClick(recipe)}
                                style={{ cursor: 'pointer' }}
                            />
                            <div className={classes.recipeListInfo} onClick={() => handleRecipeClick(recipe)} style={{ cursor: 'pointer' }}>
                                <Typography variant="body2" className={classes.recipeListName}>
                                    {recipe.recipeName}
                                </Typography>
                            </div>
                            <div className={classes.recipeListPortions}>
                                <TextField
                                    type="number"
                                    size="small"
                                    className={classes.portionsInput}
                                    inputProps={{ min: 1, max: 99, style: { textAlign: 'center', padding: '4px' } }}
                                    value={recipe.reqPortions || 1}
                                    onChange={(e) => handleUpdatePortions(recipe, e.target.value)}
                                />
                            </div>
                            <IconButton
                                className={classes.recipeListClose}
                                size="small"
                                onClick={() => handleRemoveRecipe(recipe.id)}
                                style={{ padding: '0' }}
                            >
                                <Close style={{ fontSize: '18px' }} />
                            </IconButton>
                        </div>
                        <Divider />
                    </React.Fragment>
                ))}
            </div>
        </div>
    );

    if (recipes.length <= 0) {
        return (
            <div className={classes.paper1}>
                <Typography align={"center"}>No Items are in your basket!</Typography>
            </div>
        )
    }

    return (
        <div className={classes.parent}>
            {/* Tab buttons */}
            <Box className={classes.tabButtons}>
                <Button
                    className={`${classes.tabButton} ${activeTab === 'recipes' ? classes.tabButtonActive : classes.tabButtonInactive}`}
                    onClick={() => setActiveTab('recipes')}
                >
                    Recipes
                </Button>
                <Button
                    className={`${classes.tabButton} ${activeTab === 'ingredients' ? classes.tabButtonActive : classes.tabButtonInactive}`}
                    onClick={() => setActiveTab('ingredients')}
                >
                    Ingredients
                </Button>
            </Box>

            {/* Recipes Tab */}
            <Collapse in={activeTab === 'recipes'}>
                {renderListView()}
            </Collapse>

            {/* Ingredients Tab */}
            <Collapse in={activeTab === 'ingredients'}>
                <div className={classes.ingredientCard}>
                {baskets.length>1 && <Tooltip enterTouchDelay={0} title={
                    <React.Fragment>
                        <Typography variant={"subtitle2"} className={classes.subTitle}>
                           You have a lot of ingredients so we need to add in stages!
                            Please go through each Button Below!
                        </Typography>
                    </React.Fragment>
                }>
                    <IconButton>
                        <Help/>
                    </IconButton>
                </Tooltip>}

                {baskets && baskets.length > 0 && (
                    <div className={classes.addButtons}>
                        {baskets.map((basket, idx)=>
                        <form style={{width: "100%", height: "100%"}} target="_blank" method="POST"
                              action={`https://www.amazon.co.uk/afx/ingredients/landing?almBrandId=${brandID}`} key={idx}>
                            <input type="hidden" id="afx-ingredients-verified-hidden-input" name="ingredients" value={basket}/>
                            <input type="hidden" id="afx-ingredients-verified-hidden-input-associateTag" name="associateTag" value={amazonTag}/>
                            <Button style={{width: "100%", height: "100%"}} variant="contained" color="secondary"
                                    type="submit">
                                Checkout {idx>0 ?idx:""}
                            </Button>
                        </form>
                        )}
                    </div>
                )}

                    <div className={classes.ingredientList}>
                        {Object.entries(
                            ingredientList.reduce((groups, ingredient) => {
                                const category = ingredient.category || 'OTHER';
                                if (!groups[category]) groups[category] = [];
                                groups[category].push(ingredient);
                                return groups;
                            }, {})
                        )
                        .sort(([catA], [catB]) => {
                            const orderA = ingredientCategories[catA]?.order ?? 999;
                            const orderB = ingredientCategories[catB]?.order ?? 999;
                            return orderA - orderB;
                        })
                        .map(([category, ingredients]) => (
                            <div key={category}>
                                <Typography variant="caption" className={classes.categoryHeader}>
                                    {ingredientCategories[category]?.displayName || category.charAt(0) + category.slice(1).toLowerCase().replace(/_/g, ' ')}
                                </Typography>
                                {ingredients
                                    .sort((a, b) => a.name.localeCompare(b.name))
                                    .map(x => (
                                    <div className={classes.paper} key={x.id}>
                                        <Ingredient ingredient={x} multiFactor={1} onUpdate={handleIngredientUpdate}/>
                                        <Divider/>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </Collapse>
        </div>
    )
}
